<template>
  <PageWrapper exclude-nav>
    <template #content>
      <div class="grid place-items-center overflow-y-auto p-16">
        <div
          class="mx-auto block max-w-screen-sm space-y-4 rounded-2xl p-12"
          :class="[display_error ? 'bg-red-300' : 'bg-gray-100']"
        >
          <h1 v-if="display_error" class="text-2xl font-bold">
            Uh oh, log out failed. Please try again later.
          </h1>
          <div v-else>
            <h1 class="text-3xl font-bold pb-4">
              {{
                loading ? "Logging you out..." : "Looks like you're logged out."
              }}
            </h1>
            <div v-if="!loading">
              <RouterLink
                to="/login/"
                class="block text-center px-4 py-3 bg-gray-700 font-bold rounded-lg hover:bg-gray-600 transition-colors text-white no-underline w-full"
              >
                Log In
              </RouterLink>
            </div>
          </div>
        </div>
      </div>
    </template>
  </PageWrapper>
</template>

<script setup>
import { useLocalStorage } from "@vueuse/core";
import { onMounted, ref } from "vue";
import PageWrapper from "@/components/PageWrapper.vue";
import useUserStore from "@/stores/user";

const userStore = useUserStore();

const display_error = ref(false);
const loading = ref(true);
const signedOut = ref(false);
const lastLoginAttempt = useLocalStorage("lastLoginAttempt", null);

onMounted(async () => {
  const response = await fetch("/signout/");

  if (response.ok) {
    window.csrf_token = null;

    userStore.reset();
    lastLoginAttempt.value = null;

    loading.value = false;
    signedOut.value = true;
  } else {
    display_error.value = true;
    const responseError = new Error(error.value);
    responseError.response = response;
    throw responseError;
  }
});

defineExpose({
  signedOut,
  loading,
  display_error,
});
</script>
